import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // on change input name cats[], filter .o-list-rows__item by data-cats
        this.el.querySelectorAll('input[name="cats[]"]').forEach((input) => {
            input.addEventListener('change', () => {
                this.filterByCats();
            });
        });
    }

    filterByCats() {
        const cats = [];
        this.el.querySelectorAll('input[name="cats[]"]:checked').forEach((input) => {
            cats.push(input.value);
        });

        if (cats.length === 0) {
            document.querySelectorAll('.outil-item').forEach((item) => {
                item.style.display = 'block';
            });
            return;
        }

        document.querySelectorAll('.outil-item').forEach((item) => {
            const dataCats = item.getAttribute('data-cats').split(',');
            let match = false;
            dataCats.forEach((dataCat) => {
                if (cats.indexOf(dataCat) !== -1) {
                    match = true;
                }
            });

            if (match) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });
    }
}
